// 娱乐大厅相关接口
import service from ".."

// 获取数据
export function playIndex (params) {
  return service({
    method: 'GET',
    url: "/play/index",
    params
  })
}